<template>
  <v-footer class="pa-0" dark>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn plain text class="overline" v-on="on" @click="actualizar">
          {{ $appNombre }}
        </v-btn>
      </template>
      <span>{{ $appVersion }} - Comprobar Actualizaciones</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          plain
          text
          class="overline"
          v-on="on"
          href="https://ekogroup.com.ar"
          target="_blank"
        >
          {{ mensaje }}
        </v-btn>
      </template>
      <span>Contáctenos</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          plain
          text
          class="overline"
          v-on="on"
          href="https://ekogroup.com.ar"
          target="_blank"
        >
          {{ $appAutor }}
        </v-btn>
      </template>
      <span>Visite nuestro sitio</span>
    </v-tooltip>
  </v-footer>
</template>

<script>
export default {
  name: "PiePagina",
  props: ["mensaje"],
  methods: {
    actualizar() {
      this.$router.push("/");
      location.reload(true);
    }
  }
};
</script>
